import { EntityTypes } from "../../EntityTypes";
import { IProfessionalSituationResource } from "../../professional-situations";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { IBrief } from "../types/IBrief";
import { IBriefDeliverable } from "../types/IBriefDeliverable";

export type IBriefUpdateMutationParameters = {
    brief: RelationalValue<IBrief>;
    data: Partial<
        Pick<
            IBrief,
            | "title"
            | "context"
            | "description"
            | "expectedWork"
            | "pedagogicModalities"
            | "performanceCriteria"
            | "status"
            | "isReflectiveAnalysisEnabled"
            | "estimatedDuration"
        >
    > & {
        deliverables?: IBriefDeliverable[];
        image?: string;
        skillLevels?: string[];
        tags?: string[];
        media?: string[];
        professionalSituation?: RelationalValue<IProfessionalSituationResource>;
    };
};

export type IBriefUpdateMutationResult = IBrief;

export const briefUpdateMutation: IApiMutationFunction<IBriefUpdateMutationParameters> = ({ brief, data }) => {
    const { professionalSituation, ...restData } = data;

    return {
        method: "PUT",
        url: `/briefs/${mapRelationalValue(brief)}`,
        data: {
            ...restData,
            professionalSituation: mapRelationalValueAsIRI(EntityTypes.PROFESSIONAL_SITUATION, professionalSituation),
        },
    };
};

export const useBriefUpdateMutation = createApiMutationHook<IBriefUpdateMutationParameters, IBriefUpdateMutationResult>(
    briefUpdateMutation,
);
